/**
 * Author: Housefolios
 * Created: 2025-01-27 16:41:43
 * Modified by: David Helmick
 * Modified: 2025-01-27 16:59:48
 * Description: The dialog for uploading contacts from Excel/CSV files with multiple tabs
 */

import React, { useState } from 'react'
import {
  Grid, AppBar, Button, Card, Dialog,  Slide, Toolbar, Typography, IconButton } from '@mui/material'

import UploadContactsStepper from './UploadContactsStepper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LaunchpadButton } from '@/housefolios-components/shared'

// Use Slide directly as TransitionComponent to avoid TS prop mismatch

export default function UploadContactsDialog(props) {
  const [canGoBack, setCanGoBack] = useState(false)

  const stopPropagationForTab = (event) => {
    if (event.key === 'Tab') {
      event.stopPropagation()
    }
  }

  const handleCloseUploadContacts = () => {
    if (props.onClose) {
      props.onClose()
    }
  }

  return (
    <>
      {props.nav && (
        <LaunchpadButton
          title="Upload Contacts"
          subtitle="Upload Excel/CSV file with multiple tabs"
          icon={['fas', 'upload']}
          onClick={() => props.onOpen && props.onOpen()}
          to=""
          disabled={false}
          disabledTitle=""
          children={null}
        />
      )}
      {props.launchpad && (
        <LaunchpadButton
          title="Upload Contacts"
          subtitle="Upload spreadsheet with tabs"
          icon={['far', 'file-excel']}
          onClick={() => props.onOpen && props.onOpen()}
          to=""
          disabled={false}
          disabledTitle=""
          children={null}
        />
      )}
      {props.menu && (
        <Grid size={{sm: 6}}>
          <LaunchpadButton
            title="Upload Contacts"
            subtitle="Upload spreadsheet with tabs"
            icon={['far', 'file-excel']}
            onClick={() => props.onOpen && props.onOpen()}
            disabled={props.disabled}
            to=""
            disabledTitle=""
            children={null}
          />
        </Grid>
      )}
      <Dialog
        fullScreen
        open={props.open || false}
        onClose={handleCloseUploadContacts}
        onKeyDown={stopPropagationForTab}
        slots={{
          transition: Slide
        }}
      >
        <AppBar enableColorOnDark sx={{ position: 'fixed' }}>
          <Toolbar>
            {canGoBack && (
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleCloseUploadContacts}
                aria-label="back"
              >
                <FontAwesomeIcon icon={['far', 'arrow-left']} />
              </IconButton>
            )}
            <Typography variant="h6" sx={{ ml: 3, color: 'white', flex: 1 }}>
              Upload Contacts
            </Typography>
            <Button
              variant="outlined"
              style={{ color: 'white', borderColor: 'white' }}
              onClick={handleCloseUploadContacts}
            >
              Cancel
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container>
          <Grid size={12}
            style={{ paddingLeft: 30, paddingRight: 30 }}
          >
            <Grid container>
              <Grid size={12}
                style={{
                  marginTop: 100,
                  marginBottom: 50}}
              >
                <Card>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    style={{ padding: 20 }}
                    sx={{
                      alignItems: "center"
                    }}
                  >
                    <Grid>
                      <Typography variant="h6" color="primary">
                        Upload Contact Spreadsheet
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                      >
                        Upload an Excel file with multiple tabs. Each
                        tab will be mapped to a contact type:
                      </Typography>
                      <ul style={{ marginTop: 10, marginBottom: 10 }}>
                        <li>
                          <strong>Contractors</strong> → Contractor
                        </li>
                        <li>
                          <strong>Inspectors</strong> → Home Inspector
                        </li>
                        <li>
                          <strong>Realtors</strong> → Agent
                        </li>
                        <li>
                          <strong>Lenders</strong> → Hard Money Lender
                        </li>
                        <li>
                          <strong>Insurance</strong> → Insurance Agent
                        </li>
                        <li>
                          <strong>Title</strong> → Title Company
                        </li>
                        <li>
                          <strong>Investors</strong> → Investor
                        </li>
                        <li>
                          <strong>Buyers</strong> → Buyer
                        </li>
                        <li>
                          <strong>Sellers</strong> → Seller
                        </li>
                        <li>
                          <strong>Property Managers</strong> →
                          Property Manager
                        </li>
                      </ul>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid size={12}
                style={{
                  marginBottom: 100}}
              >
                <UploadContactsStepper
                  openUploadContacts={props.open || false}
                  handleCloseUploadContacts={
                    handleCloseUploadContacts
                  }
                  onContactsImported={props.onContactsImported}
                  onActiveStepChange={(step) =>
                    setCanGoBack(step > 0)
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}
